import apiClient from '@/services/http/client'
import type {
  StudioMetrics,
  DashboardInsights,
  DailyReservationInsight,
  TopClassInsight,
  InsightsQuery,
  StudioBroadcast,
} from '@/types'

export const fetchStudioMetrics = async (): Promise<StudioMetrics> => {
  const response = await apiClient.get<{ data: StudioMetrics }>('/api/v1/dashboard/metrics')
  return response.data.data
}

export const fetchDashboardInsights = async (params: InsightsQuery = {}): Promise<DashboardInsights> => {
  const response = await apiClient.get('/api/v1/dashboard/insights', { params })
  return response.data.data
}

export const fetchDashboardInsightsDaily = async (params: InsightsQuery = {}): Promise<DailyReservationInsight[]> => {
  const response = await apiClient.get('/api/v1/dashboard/insights/daily', { params })
  return response.data.data
}

export const fetchDashboardTopClasses = async (params: InsightsQuery = {}): Promise<TopClassInsight[]> => {
  const response = await apiClient.get('/api/v1/dashboard/insights/top-classes', { params })
  return response.data.data
}

export const fetchStudioBroadcasts = async (): Promise<StudioBroadcast[]> => {
  const response = await apiClient.get('/api/v1/broadcasts')
  return response.data.data ?? []
}

export const markStudioBroadcastAsRead = async (
  id: number,
): Promise<{ broadcast_id: number; read: boolean }> => {
  const response = await apiClient.post(`/api/v1/broadcasts/${id}/read`)
  return response.data.data
}
